import { colors } from '../styles/variables';

export const coursesData = [
  {
    tag: '입문자 환영',
    title: 'Java 기초 과정',
    description: '코딩 경험이 전혀 없어도 시작할 수 있도록 Java 문법, 객체지향 사고, 기본 프로젝트 흐름을 단계적으로 익힙니다. 실습을 통해 프로그래밍 기초 체력을 탄탄하게 다집니다.',
    features: [
      '개념부터 시작하는 눈높이 교육',
      '실무 프로그래밍 마인드셋 함양',
      '개인 맞춤형 학습 속도 조절'
    ],
    imageClass: 'java',
    bgColor: colors.javaColor,
    bgImage: '/assets/images/course-thumb-java.png',
    link: '/java',
    reviews: [
      { name: '이0훈', text: '비전공자도 이해할 수 있도록 커리큘럼이 잘 짜여 있습니다.', stars: 5 },
      { name: '천00엘', text: '실습 위주라서 금방 따라갈 수 있었어요!', stars: 5 },
      { name: '이0수', role: '전기공학 3학년', text: '전공 수업을 따라가는 것만으로 벅찬 와중에, 멘토님이 제가 짠 코드를 한 줄씩 같이 봐 주셨던 게 가장 큰 도움이었어요. "왜 이렇게 짰지?"가 자연스럽게 "이렇게 짜면 어떨까?"로 바뀌더라고요.', stars: 5 }
    ]
  },
  {
    tag: '실무 역량 강화',
    title: 'Java 심화 과정',
    description: 'Java 기본기를 바탕으로 Spring, API 설계, 아키텍처 흐름을 실무 관점에서 학습합니다. 현업 개발 방식에 가까운 프로젝트로 백엔드 포트폴리오를 구축합니다.',
    features: [
      '객체지향 설계 심화 및 디자인 패턴',
      'Spring Framework 기반 웹 개발',
      'MSA 아키텍처와 클라우드 환경 이해'
    ],
    imageClass: 'java-advanced',
    bgColor: colors.javaAdvancedColor,
    bgImage: '/assets/images/course-thumb-java-advanced.png',
    link: '/java-advanced',
    reviews: [
      { name: '김0윤', text: '포트폴리오를 완성할 수 있어서 자신감이 생겼어요.', stars: 5 },
      { name: '천00엘', text: 'Spring 핵심을 실무적으로 배울 수 있어 좋았습니다.', stars: 5 }
    ]
  },
  {
    tag: '시스템 프로그래밍',
    title: 'C 프로그래밍',
    description: 'C언어의 문법뿐 아니라 메모리, 포인터, 자료구조를 함께 다룹니다. 컴퓨터가 코드를 실행하는 방식을 이해하며 시스템 프로그래밍 기초를 쌓습니다.',
    features: [
      '메모리 구조와 포인터 완벽 이해',
      '효율적인 자료구조와 알고리즘 구현',
      '임베디드 시스템 응용 과정'
    ],
    imageClass: 'c',
    bgColor: colors.cColor,
    bgImage: '/assets/images/course-thumb-c.png',
    link: '/c',
    reviews: [
      { name: '함0현', text: '실무에서 바로 쓸 수 있는 기술을 배워서 취업에 큰 도움이 됐습니다.', stars: 5 },
      { name: '이0복', text: '자료구조와 알고리즘을 C로 직접 구현해보니 실력이 많이 늘었습니다.', stars: 5 },
      { name: '이0연', text: '임베디드 시스템까지 다뤄서 취업 준비에 큰 도움이 됐어요.', stars: 5 },
      { name: '강0민', role: '전자공학 2학년', text: 'C 언어 기초가 부족한 채로 임베디드 쪽으로 가야 했는데, 콘솔 어드벤처 게임을 처음부터 끝까지 만들어 보면서 포인터와 메모리에 대한 막연한 두려움이 사라졌습니다.', stars: 5 }
    ]
  },
  {
    tag: '웹 프론트엔드',
    title: 'React 프론트엔드',
    description: '컴포넌트 설계, 상태 관리, API 연동, 배포 흐름까지 React 실무 개발에 필요한 핵심을 익힙니다. 사용자 경험을 고려한 프론트엔드 구현 역량을 키웁니다.',
    features: [
      '컴포넌트 기반 UI 개발 방법론',
      '상태 관리와 리액트 훅스 활용',
      'GitHub 협업과 CI/CD 구축'
    ],
    imageClass: 'react',
    bgColor: colors.reactColor,
    bgImage: '/assets/images/course-thumb-react.png',
    link: '/react',
    reviews: [
      { name: '이0훈', text: '실제 프로젝트를 하면서 자신감이 생겼어요.', stars: 5 },
      { name: '박0서', text: '협업과 배포까지 경험할 수 있어 유익했습니다.', stars: 5 },
      { name: '박0현', role: '비전공 직장인', text: '책으로 React를 두 번 봐도 직접 만들면 막히던 게, 1:1로 페어 프로그래밍하면서 한 사이클 끝내고 나니 다음 프로젝트는 혼자도 시작할 수 있게 됐어요. 공식 문서를 어떻게 읽는지를 배운 셈입니다.', stars: 5 }
    ]
  },
  {
    tag: '데이터 관리',
    title: '데이터베이스 모델링',
    description: '서비스 요구사항을 데이터 구조로 바꾸는 모델링 과정을 학습합니다. 정규화, 관계 설계, SQL 최적화까지 실제 시스템에 적용 가능한 DB 역량을 갖춥니다.',
    features: [
      '관계형 DB 설계와 정규화 기법',
      'SQL 최적화와 인덱싱 전략',
      'NoSQL과 분산 데이터베이스'
    ],
    imageClass: 'database',
    bgColor: colors.dbColor,
    bgImage: '/assets/images/course-thumb-database.png',
    link: '/database',
    reviews: [
      { name: '김0윤', text: 'SQL 최적화와 인덱싱 전략이 실무에 큰 도움이 됐습니다.', stars: 5 },
      { name: '천00엘', text: 'React의 핵심을 실무적으로 배울 수 있어 좋았습니다.', stars: 5 },
      { name: '함0현', text: '실무에서 바로 쓸 수 있는 기술을 배워서 취업에 큰 도움이 됐습니다.', stars: 5 },
      { name: '한0민', role: '정보통신 4학년', text: 'DB 모델링이 학교 수업에서는 너무 추상적으로만 다뤄져서 답답했는데, 실제 운영에 가까운 시나리오로 ERD를 그리고 쿼리까지 직접 짜면서 머릿속이 정리됐어요.', stars: 5 }
    ]
  },
  {
    tag: '타입 안전성',
    title: 'TypeScript',
    description: 'JavaScript 프로젝트에 타입 시스템을 적용해 안정적인 코드를 작성하는 방법을 배웁니다. React와 함께 사용하며 대규모 프론트엔드 구조를 이해합니다.',
    features: [
      '정적 타입 시스템의 이해와 활용',
      'React와 TypeScript 통합 개발',
      '대규모 애플리케이션 설계 패턴'
    ],
    imageClass: 'typescript',
    bgColor: colors.typescriptColor,
    bgImage: '/assets/images/course-thumb-typescript.png',
    link: '/typescript',
    reviews: [
      { name: '이0연', text: 'TypeScript를 배우고 코드가 훨씬 안정적이게 됐어요.', stars: 5 },
      { name: '이0훈', text: 'React와 TypeScript를 함께 배울 수 있어 실무에 바로 적용했습니다.', stars: 5 },
      { name: '최0준', role: '주니어 프론트엔드', text: 'TypeScript 타입 시스템을 막연히 어렵게 느꼈는데, 멘토님이 실제 회사 코드 패턴 위주로 짧게 짧게 보여 주시니 일주일이 지나기 전에 자연스럽게 손에 익었습니다.', stars: 5 }
    ]
  },
  {
    tag: 'AI 개발',
    title: 'AI 코딩(Vibe Coding)',
    description: 'Copilot, Cursor, Claude 같은 AI 도구를 실제 개발 흐름에 연결하는 방법을 학습합니다. 요구사항 정리부터 구현, 리팩터링, 배포 가능한 포트폴리오 완성까지 다룹니다.',
    features: [
      'Copilot, Cursor IDE 실무 활용',
      'Claude를 통한 시스템 설계 및 최적화',
      '실제 서비스 수준의 클론 코딩'
    ],
    imageClass: 'ai-coding',
    bgColor: colors.aiColor,
    bgImage: '/assets/images/course-thumb-ai-coding.png',
    link: '/ai-coding', 
    reviews: [
      { name: '이0훈', text: 'AI 코딩을 통해서 웹 서비스를 개발 할 수 있습니다.', stars: 5 },
      { name: '김0윤', text: '자동화 프로그램을 통해서 수익 창출에 성공 했습니다.', stars: 5 },
      { name: '정0현', role: '취준생 / 백엔드 지망', text: 'AI 도구를 무작정 쓰는 게 아니라, 어떤 단계에 어디까지 맡기고 어디서 사람이 검증해야 하는지를 배운 게 가장 컸습니다. 사이드 프로젝트가 실제 라이브 데모까지 올라간 것도 처음이었어요.', stars: 5 }
    ]
  }
];
